import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import de from './locales/de.json';
import enApp from './locales/en.app.json';
import deApp from './locales/de.app.json';

const mergeLocales = (base, extra) => ({
  ...base,
  ...extra
});

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources: {
      en: { translation: mergeLocales(en, enApp) },
      de: { translation: mergeLocales(de, deApp) }
    },
    lng: 'en',
    fallbackLng: 'en',
    supportedLngs: ['en', 'de'],
    interpolation: {
      escapeValue: false
    },
    keySeparator: false,
    nsSeparator: false,
    returnEmptyString: false
  });
}

export default i18n;
